import { render, staticRenderFns } from "./OrderItemCell.vue?vue&type=template&id=13c7fd62&"
import script from "./OrderItemCell.vue?vue&type=script&lang=js&"
export * from "./OrderItemCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports